import { render, staticRenderFns } from "./TestAvatar.vue?vue&type=template&id=3d3cbc82&"
import script from "./TestAvatar.vue?vue&type=script&lang=js&"
export * from "./TestAvatar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports